import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import type { TPages, TRouteComponent } from '../../types';
import { getPage } from '../../utils/getPageConfig';
import RouteComponent from '../RouteComponent';

const RoutesFactory: Component<{ pages: TPages } & TRouteComponent> = ({
  pages,
  unAuthorizedRoute,
  homePageRoute,
  page404Route,
  pageFormFactor,
  isAuthFetched,
  isAuthenticated,
  LayoutComponent,
  LoaderComponent
}) => (
  <Routes>
    <Route path={'*'} element={<Navigate to={page404Route} replace />} />
    <Route path={'/'} element={<Navigate to={homePageRoute} replace />} />
    {Object.entries(pages).map(([path, pageConfig]) => {
      const page = getPage(pageConfig, pageFormFactor);
      return (
        <Route
          key={path}
          path={path}
          element={
            <RouteComponent
              page={page}
              unAuthorizedRoute={unAuthorizedRoute}
              homePageRoute={homePageRoute}
              isAuthFetched={isAuthFetched}
              isAuthenticated={isAuthenticated}
              pageFormFactor={pageFormFactor}
              LoaderComponent={LoaderComponent}
            >
              <LayoutComponent page={page} />
            </RouteComponent>
          }
        />
      );
    })}
  </Routes>
);
export default RoutesFactory;
